export default [
    { from: '/review-hq', to: '/review-program' },
    { from: '/program-overview', to: '/review-program' },
    { from: '/resources', to: '/review-program' },
];
